import { RichTextNodeType } from "@prismicio/types-internal/lib/customtypes"
import type { Mark } from "@tiptap/core"
import type { Mark as ProsemirrorMark, Schema } from "prosemirror-model"

import { ExtensionType } from "../../models"
import type { ExtendedRichTextNodeType } from "../../types"

export class BoldExtension {
  extType: ExtensionType.Mark = ExtensionType.Mark
  richTextNodeTypes: ExtendedRichTextNodeType[] = [RichTextNodeType.strong]
  constructor(
    readonly name: "bold",
    readonly component: Mark,
    readonly converter: {
      fromPrismic(
        schema: Schema,
      ): (elmt: BoldElement) => ProsemirrorMark | undefined
      toPrismic(elmt: ProsemirrorMark): undefined
    },
  ) {}
}

interface BoldElement {
  type: "strong" | "em" | "list-item"
  start: number
  end: number
}
